module.exports = __webpack_public_path__ + "img/fleetpoolLogisticsLogo.ee72b8f4.svg";